import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors['neutral-0']};
  border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 24px;
`;

export const Title = styled.p`
  font-family: Eina 01;
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  color: ${({ theme }) => theme.colors['neutral-70']};
  white-space: pre-line;
`;

export const Description = styled.p`
  font-family: inherit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  color: ${({ theme }) => theme.colors['neutral-100']};
`;
